import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import FloatingButton from "../../Material/FloatingButton";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import * as FileSaver from "file-saver";
import XLSX from "xlsx";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import Moment from "react-moment";

toast.configure();
class draftList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      MyApplicationList: [],
      deletePopup: false,
      deleteReferenceno: "",
      loading: "",
      downloadExcel: [],
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: "headerTitle",
      value: "My Application : Draft List",
    });
    this.GetListData("Draft");
  }

  GetListData = (val) => {
    try {
      let postData = { UserId: this.props.UserId, Status: val, userType: "" };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/MyApplication/MyApplicationList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              MyApplicationList: data?.resultObject,
              loading: "Yes",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  viewRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/draft/view?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  editRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/draft/edit?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  deleteRequest = (value, tableMeta, updateValue) => {
    this.setState({
      deletePopup: true,
      deleteReferenceno: tableMeta?.rowData[0],
    });
  };

  cancelDelete = () => {
    this.setState({ deletePopup: false, deleteReferenceno: "" });
  };

  confirmDelete = () => {
    try {
      this.setState({
        MyApplicationList: [],
        loading: "",
      });
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DeleteeDocRequest?ReferenceNo=${this.state.deleteReferenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            toast.success("Deleted successfully.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.setState({ deletePopup: false, deleteReferenceno: "" });
            this.GetListData("Draft");
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "Reference No",
        header2: "Doc Type",
        header3: "Employee",
        header4: "Created By",
        header5: "Date Created",
        header6: "Approval Status",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            "Draft",
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.MyApplicationList?.forEach((value, index) => {
          let mdData = [
            value.referenceno,
            value.edoctype,
            value.employee,
            value.createdby,
            value.createddate
              ? moment(value.createddate).format("DD-MM-yyyy HH:mm:ss")
              : "",
            value.approvalstatus,
          ];
          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "draft.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  printRequest = (value, tableMeta, updateValue) => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/draft/print?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(tableMeta.rowData?.[0]),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  render() {
    let dataArray = [];
    this.state.MyApplicationList?.map((value) => {
      let mdData = [
        value.referenceno,
        value.edoctype,
        value.employee,
        value.createdby,
        value.createddate
          ? moment(value.createddate).format("DD-MM-yyyy HH:mm:ss")
          : "",
        value.approvalstatus,
      ];
      dataArray.push(mdData);
      return null;
    });

    const columns = [
      {
        name: "referenceno",
        label: "Reference No",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "edoctype",
        label: "Doc Type",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "employee",
        label: "Employee",
        options: {
          filter: true,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "createdby",
        label: "Created By",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "createddate",
        label: "Date Created",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
        },
      },
      {
        name: "approvalstatus",
        label: "Approval Status",
        options: {
          filter: false,
          sort: true,
          viewColumns: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <div className="badge badge-draft">{value}</div>
              </>
            );
          },
        },
      },

      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/awesome-eye.svg"
                  }
                  alt="View"
                  onClick={() =>
                    this.viewRequest(value, tableMeta, updateValue)
                  }
                  data-tip="View"
                />

                <img
                  className="action-right-space mouse-pointer"
                  style={{ width: "25px" }}
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/edit-solid.svg"
                  }
                  data-tip="Edit"
                  alt="Metro Flow Tree"
                  onClick={() =>
                    this.editRequest(value, tableMeta, updateValue)
                  }
                />

                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/print-standard-pdf.svg"
                  }
                  alt="Standard Print"
                  onClick={() =>
                    this.printRequest(value, tableMeta, updateValue)
                  }
                  data-tip="Standard Print"
                />
                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/ionic-md-close.svg"
                  }
                  data-tip="Cancel"
                  alt="Close"
                  onClick={() =>
                    this.deleteRequest(value, tableMeta, updateValue)
                  }
                />
              </div>
            );
          },
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      download: false,
      print: false,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}>
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true">
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
          </>
        );
      },
    };

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>My Application : Draft List</Breadcrumb.Item>
        </Breadcrumb>
        <div className="col-xs-2">
          {" "}
          <MUIDataTable
            title={"My Application : Draft List"}
            data={dataArray}
            columns={columns}
            options={options}
          />{" "}
        </div>
        <p className="text-center"></p>
        <Modal show={this.state.deletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmDelete}>
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(draftList);
